import createVueComponent from '../createVueComponent';

const FileCheck2 = createVueComponent('FileCheck2Icon', [
  ['path', { d: 'M4 22h14a2 2 0 002-2V7.5L14.5 2H6a2 2 0 00-2 2v4' }],
  ['path', { d: 'M14 2v6h6' }],
  ['path', { d: 'M3 15l2 2 4-4' }],
]);

export default FileCheck2;
